exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#text-viewer[data-v-0c68b032]{width:50vw;max-width:680px;height:inherit;display:table}#text-viewer .title[data-v-0c68b032]{font-weight:700!important}#text-viewer .subtitle[data-v-0c68b032]{color:#5b6981}", ""]);

// exports
